<div
  id="step-{{ step?.id }}"
  class="full-width full-height d-flex gap-1"
  cdkDropList
  [cdkDropListConnectedTo]="stepDropLists"
  [cdkDropListDisabled]="disabled"
  [cdkDropListData]="tasks"
  (cdkDropListEntered)="dragging = true"
  (cdkDropListDropped)="dragging = false; drop($event)"
  [cdkDropListOrientation]="!checkDFlexWrap() ? 'horizontal' : 'vertical'"
  [class.flex-wrap]="checkDFlexWrap() && !dragging"
  (cdkDragEnded)="dragging = false"
>
  <div
    *ngFor="let task of tasks; trackBy: trackByTaskId"
    class="flex-auto"
    [ngClass]="{ 'flex-wide': task.component?.fullWidth }"
  >
    <div
      *ngIf="task.component"
      cdkDrag
      class="task-wrapper d-flex mb-1"
      [cdkDragDisabled]="disabled"
    >
      <div
        class="full-width"
        (mouseenter)="service.taskHover = true"
        (mouseleave)="service.taskHover = false"
      >
        <div class="drag-handle d-flex">
          <button
            mat-icon-button
            *ngIf="!disabled"
            cdkDragHandle
            color="accent"
            style="cursor: move"
          >
            <mat-icon>reorder</mat-icon>
          </button>
        </div>
        <div class="d-flex full-width boxed">
          <workflow-task
            id="task-{{ task.id }}"
            class="full-width"
            [task]="task"
            [wfTableConfig]="wfTableConfig"
            [disabled]="disabled"
            (delete)="delete($event)"
            (duplicate)="duplicate($event)"
            (change)="change($event)"
          ></workflow-task>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- This container is only for a New Task -->
<ng-container *ngFor="let task of tasks">
  <div *ngIf="!task.component">
    <div
      class="d-flex full-width boxed mt-2"
      (mouseenter)="service.taskHover = true"
      (mouseleave)="service.taskHover = false"
    >
      <workflow-task
        class="full-width"
        [task]="task"
        [wfTableConfig]="wfTableConfig"
        [disabled]="disabled"
        (delete)="delete($event)"
        (duplicate)="duplicate($event)"
        (change)="change($event)"
      ></workflow-task>
    </div>
  </div>
</ng-container>

<!-- <button
  class="mt-2 ml-1"
  mat-stroked-button
  color="accent"
  *ngIf="!disabled"
  (click)="add()"
  [matTooltip]="'Add New Task'"
>
  <mat-icon>add_box</mat-icon>Add Task
</button> -->
